import { render } from "./thank_you.html?vue&type=template&id=8fd661c4&scoped=true&external"
import script from "./thank_you.js?vue&type=script&lang=js&external"
export * from "./thank_you.js?vue&type=script&lang=js&external"

import "./ThankYou.vue?vue&type=style&index=0&id=8fd661c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd661c4"]])

export default __exports__